import React, { Component } from 'react';
import { any, string, arrayOf, shape, func } from 'prop-types';
import Radium from 'radium';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';

import UTCheck from '../UTCheck';
import { message } from '../../../utils/stringUtils';

import RadiumStyles from './RadiumStyles';
import styles from './styles';

class AccountSelect extends Component {
  state = { selectedOption: this.props.selectedOption };

  onSelection = selected => {
    if (selected) {
      const originalOption = this.props.options.filter(x => x[this.props.keyProp] === selected.value)[0];
      this.setState({ selectedOption: originalOption });
      this.props.onSelect(originalOption);
    }
  };

  onOpen = () => this.setState({ selectedOption: null });

  onClose = () => this.setState({ selectedOption: this.props.selectedOption });

  optionText = opt => appConfig.accountSelectKeys.map(labelKey => ` ${labelKey.prefix} ${opt[labelKey.key]}`);

  optionRenderer = opt => {
    const selected = this.props.selectedOption && this.props.selectedOption[this.props.keyProp] === opt.value;

    return (
      <div style={selected ? styles.selectedOption : styles.normalOption}>
        <UTLabel small>{opt.label}</UTLabel>
        {selected && <UTCheck style={styles.checkedOk} />}
      </div>
    );
  };

  render() {
    return (
      <div style={this.props.style}>
        <RadiumStyles />
        <Select
          value={
            this.state.selectedOption
              ? { value: this.state.selectedOption.id, label: this.optionText(this.state.selectedOption) }
              : this.props.emptyLabel
          }
          placeholder={this.props.filterPlaceholder}
          clearable={false}
          onChange={this.onSelection}
          options={this.props.options.map(opt => ({
            value: opt.id,
            label: this.optionText(opt)
          }))}
          wrapperStyle={styles.wrapper}
          menuStyle={styles.menu}
          menuContainerStyle={styles.menu}
          style={styles.control}
          onOpen={this.onOpen}
          onClose={this.onClose}
          optionRenderer={this.optionRenderer}
          noResultsText={this.props.emptyLabel || message('ErrorScreen:noItemsError')}
        />
      </div>
    );
  }
}

AccountSelect.propTypes = {
  options: arrayOf(shape({ label: string })),
  selectedOption: any, // eslint-disable-line react/forbid-prop-types
  filterPlaceholder: string,
  emptyLabel: string,
  onSelect: func.isRequired,
  keyProp: string
};

export default Radium(AccountSelect);
